// src/ui/Topbar.jsx
import { Menu, LogOut, ChevronDown } from "lucide-react";
import { useAuth } from "../auth/AuthContext";
import { useNavigate } from "react-router-dom";

export default function Topbar({ onToggleSidebar }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const onLogout = () => {
    logout();
    nav("/login");
  };

  return (
    <header className="sticky top-0 z-40 w-full border-b border-neutral-800 bg-neutral-950/70 backdrop-blur">
      <div className="mx-auto max-w-[1400px] px-3 md:px-6 h-14 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <button
            onClick={onToggleSidebar}
            className="inline-flex h-9 w-9 items-center justify-center rounded-xl hover:bg-neutral-800"
            aria-label="Alternar menú"
          >
            <Menu className="h-5 w-5" />
          </button>

          <a href="/" className="flex items-center gap-3">
            <div className="grid h-9 w-9 place-items-center rounded-xl bg-emerald-500 font-bold">
              WA
            </div>
            <div className="leading-tight">
              <div className="text-sm font-semibold">WhatsPlatinum</div>
              <div className="text-[11px] text-neutral-400">Panel profesional</div>
            </div>
          </a>
        </div>

        <div className="flex items-center gap-3">
          {/* Zona derecha: usuario */}
          <div className="group relative">
            <button className="flex items-center gap-2 rounded-xl bg-neutral-800 px-3 py-1.5 text-sm hover:bg-neutral-700">
              <div className="h-6 w-6 grid place-items-center rounded-md bg-neutral-700">👤</div>
              <span className="hidden sm:block">{user?.name ?? "Admin"}</span>
              <ChevronDown className="h-4 w-4" />
            </button>
            <div className="invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-all absolute right-0 mt-2 w-44 rounded-xl border border-neutral-800 bg-neutral-900 p-1 shadow-xl">
              <button
                onClick={onLogout}
                className="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm hover:bg-neutral-800"
              >
                <LogOut className="h-4 w-4" />
                Salir
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
 